/* 孫吳傳・第 4 章：陽人斬華雄（初平二年，191）
 * 史實：《三國志·孫堅傳》「堅復相收兵，合戰於陽人，大破卓軍，梟其都督華雄等。」
 *       《英雄記》（裴注）：胡軫為大督護、呂布為騎督，兩人不和；呂布等謊稱城中賊已走，誘全軍連夜趕到陽人，人馬疲憊，大敗。
 * 流程：收攏梁東之戰後散落的部隊（限時，找回越多守城越輕鬆）→ 守住陽人城的東門，撐過三波 →
 *       卓軍人馬疲憊（移速、攻擊下降），出城直取華雄 → 梟華雄即勝利；篇末旁白交代孫堅之死。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, boss, ally, allyTick, TROOPS, PEOPLE, rout, vanish } from '../kit.ts';
import { CITY, GATE } from '../maps/yangren.ts';

const LV = 8, GATHER_T = 100, HOLD_T = 75, GATE_HP = 3000;
const SPOTS = [[2400, 1600], [2400, 4000], [4200, 1000], [4300, 4600], [5200, 2000], [1300, 3900]];
const FRONT = [GATE[0] + 130, GATE[1]], CAMP = [7000, 2800];
const FOE = { spec: TROOPS.dong, name: '涼州兵', hp: 460, maxHp: 460, atk: 26, ms: 240 };

export default {
  id: 'sunwu-4', map: 'yangren', hero: 'sunjian',
  title: '第 3 章　陽人斬華雄', year: '初平二年（191）',
  brief: {
    quote: [{ text: '堅復相收兵，合戰於陽人，大破卓軍，梟其都督華雄等。', src: '《三國志·吳書·孫堅傳》' }],
    text: '梁東一敗，孫堅的部眾散落四方。董卓派胡軫為大督護、呂布為騎督、華雄為都督，率軍來攻陽人。',
    goals: ['收攏散落的部隊', '守住陽人城的東門', '出城擊殺華雄'],
  },
  words: { ally: '部眾', foe: '涼州兵' },
  stars: [
    { text: '收攏 12 人以上', ok: (m) => m.vars.got >= 12 },
    { text: '城門的耐久保住一半以上', ok: (m) => m.vars.gateMin >= GATE_HP / 2 },
    { text: '出城後 60 秒內梟華雄', ok: (m) => m.vars.sallyT != null && m.vars.killT - m.vars.sallyT <= 60 },
  ],
  steps: [
    { // 1. 收攏散兵
      enter(m, w) {
        const me = w.player;
        setLevel(w, me, LV);
        me.x = CITY.x + 300; me.y = CITY.y;
        m.vars.got = 0; m.vars.gateHp = GATE_HP; m.vars.gateMin = GATE_HP;
        m.vars.lost = SPOTS.map(([x, y], g) => {
          m.mark('s' + g, x, y, '散兵', true);
          return Array.from({ length: 3 }, (_, i) => { const u = m.recruit(x + (i - 1) * 50, y + (i % 2) * 40, '孫堅部眾'); u.group = g; u.hp = u.maxHp = 560; u.atk = 24; return u; });
        });
        // 卓軍的斥候在城外遊走
        m.vars.scouts = [[4200, 1900], [4200, 3700], [3100, 1500], [3200, 4200]].map(([x, y]) => { const u = m.foe('huangjin', x, y, FOE); m.patrol(u, [[x, y], [x + 500, y + (y < 2800 ? 300 : -300)]]); return u; });
        m.card('堅復相收兵。', '《孫堅傳》');
        m.line('孫堅', '梁東一敗，弟兄們都散了。趁卓軍還沒到，把人找回來！');
        m.obj('gather', '收攏散落的部隊', SPOTS.length * 3);
        m.obj('time', '');
        m.after(5, () => m.i === 0 && m.line('提示', '地圖上的「散兵」標記是躲在附近的部眾，走過去他們就會跟上。卓軍到之前要回城。'));
      },
      tick(m, w) {
        const me = w.player;
        m.vars.lost.forEach((list, g) => {
          for (const u of list) if (u.alive && !u.owner && SG.gd(u.x, u.y, me.x, me.y) < 170) { m.join(u, me); m.vars.got++; m.unmark('s' + g); if (m.vars.got % 3 === 1) m.line('部眾', '是孫將軍！我們跟您走！'); }
        });
        m.prog('gather', m.vars.got);
        const left = Math.max(0, Math.ceil(GATHER_T - m.t));
        m.get('time').text = `卓軍 ${left} 秒後到陽人`;
        return m.t >= GATHER_T || m.vars.got >= SPOTS.length * 3;
      },
    },
    { // 2. 守東門：三波
      enter(m, w) {
        const me = w.player;
        m.drop('time'); m.done('gather');
        for (let g = 0; g < SPOTS.length; g++) m.unmark('s' + g);
        for (const list of m.vars.lost) for (const u of list) if (u.alive && !u.owner) { u.alive = false; u.counted = true; } // 沒找回來的就散了
        rout(m, w, m.vars.scouts, CAMP);
        m.big('卓軍來了！');
        m.line('孫堅', '回城！守住東門！');
        m.after(4, () => m.line('提示', '城頭的弓手會往城門前射箭（黃圈）；找回的部眾越多，射得越密。城裡（本營）可以用殺敵得來的金錢買裝備。'));
        m.gate('east', GATE[0], GATE[1], 180, 'citygate', null, { hp: GATE_HP, hp0: GATE_HP });
        m.mark('gate', GATE[0], GATE[1], '東門');
        m.obj('hold', '守住東門');
        m.vars.waves = [];
        // 三波：每 25 秒一波，從東邊沿大路來
        [0, 25, 50].forEach((t, k) => m.after(t, () => {
          const n = 8 + k * 3, list = Array.from({ length: n }, (_, i) => m.foe(i === 0 ? 'bandit' : 'huangjin', CAMP[0] - 1500 - (i % 4) * 80, CAMP[1] - 150 + Math.floor(i / 4) * 100, i === 0 ? { spec: TROOPS.dong, name: '涼州校尉' } : FOE));
          for (const u of list) u.home = [FRONT[0] + 60 + SG.rand() * 140, FRONT[1] + (SG.rand() - 0.5) * 220];
          m.vars.waves.push(...list);
          m.big(`第 ${k + 1} 波`);
        }));
        m.vars.hold0 = w.t;
      },
      tick(m, w, dt) {
        const g = m.gates.find((x) => x.id === 'east'), V = m.vars;
        // 攻門：門前沒在打人的涼州兵會砍門
        let n = 0;
        for (const u of V.waves) if (u.alive && !(u.target && u.target.alive) && SG.gd(u.x, u.y, FRONT[0], FRONT[1]) < 260) { n++; u.f = -1; }
        if (n) { V.gateHp -= n * 9 * dt; V.sparkT = (V.sparkT || 0) - dt; if (V.sparkT <= 0) { V.sparkT = 0.5; w.fx({ k: 'spark', x: GATE[0], y: GATE[1] - 50, col: '#ffcf70' }); } }
        // 城頭的弓手：往城門前的涼州兵射（收攏的人越多，射得越密）
        V.volT = (V.volT || 0) - dt;
        if (V.volT <= 0) {
          V.volT = Math.max(0.6, 1.6 - V.got * 0.05);
          const near = V.waves.filter((u) => u.alive && SG.gd(u.x, u.y, FRONT[0], FRONT[1]) < 700);
          if (near.length) { const t = near[Math.floor(SG.rand() * near.length)]; m.strike(t.x, t.y, 100, 0.9, 80, 1, { col: '#ffd060' }); }
        }
        V.gateMin = Math.min(V.gateMin, V.gateHp);
        g.hp = Math.max(0, V.gateHp);
        const o = m.get('hold'), left = Math.max(0, Math.ceil(HOLD_T - (w.t - V.hold0)));
        o.text = `守住東門（城門 ${Math.round((100 * g.hp) / GATE_HP)}%，還要撐 ${left} 秒）`;
        if (V.gateHp <= 0) { m.lose('東門被攻破'); return false; }
        return w.t - V.hold0 >= HOLD_T;
      },
    },
    { // 3. 卓軍疲憊：出城梟華雄
      enter(m, w) {
        const V = m.vars;
        m.done('hold'); m.unmark('gate');
        m.ungate('east');
        m.line('旁白', '胡軫與呂布不和，呂布謊稱城中賊已走，誘全軍連夜趕路，人馬疲頓（據《英雄記》）。');
        m.after(2, () => m.line('孫堅', '卓軍連夜趕路，已經疲憊不堪了。開城門，出城直取華雄！'));
        V.cp = ally(w, 'chengpu', GATE[0] - 150, GATE[1] + 60, w.player.lv);
        m.after(3.5, () => m.line('程普', '程普願隨主公出城！'));
        const left = m.alive(V.waves);
        rout(m, w, left.slice(0, Math.floor(left.length * 0.7)), [8300, 2800]); // 人馬疲頓：大半潰散
        for (const u of m.alive(V.waves)) w.addBuff(u, { id: '疲頓', t: 9999, neg: true, ms: -0.3, atkP: -0.3 });
        const hx = boss(w, PEOPLE.huaxiong, CAMP[0] - 600, CAMP[1], { hp: 3400, atk: 50, armor: 7, name: '華雄', ms: 230 });
        w.addBuff(hx, { id: '疲頓', t: 9999, neg: true, ms: -0.2, atkP: -0.2 });
        V.hx = hx; V.guard = m.camp(hx.x, hx.y, [['huangjin', 3]], 240).map((u) => Object.assign(u, { spec: TROOPS.dong, name: '涼州兵' }));
        // 呂布：在後頭觀望，不久就走了
        const lb = boss(w, SG.LUBU, CAMP[0] + 400, CAMP[1] - 400, { name: '呂布', untargetable: true, hp: 9999 });
        lb.home = [CAMP[0] + 400, CAMP[1] - 400]; V.lb = lb;
        m.after(30, () => { if (!m.over) { m.line('呂布', '胡軫自己打去吧，我們走！'); lb.home = [8300, 1200]; m.after(6, () => vanish(w, lb)); } });
        m.mark('hx', hx.x, hx.y, '華雄', false, hx);
        m.obj('hx', '出城擊殺華雄');
        V.sallyT = w.t;
      },
      tick(m, w) {
        const V = m.vars;
        if (V.hx.alive) return false;
        V.killT = w.t;
        m.done('hx'); m.unmark('hx');
        m.big('梟其都督華雄！');
        m.card('合戰於陽人，大破卓軍，梟其都督華雄等。', '《孫堅傳》');
        rout(m, w, V.guard.concat(V.waves), [8300, 2800]);
        m.after(4.5, () => m.card('單馬行峴山，爲祖軍士所射殺。', '《孫堅傳》（初平三年，孫堅攻劉表）'));
        m.after(8, () => m.win());
        return true;
      },
    },
    { tick() { return false; } },
  ],
  always(m, w) {
    if (!w.player.alive) { m.lose('孫堅陣亡'); return; }
    if (m.vars.cp) allyTick(w, m.vars.cp, w.player);
  },
};
